/**
 * Convert a stored profile-photo path (as returned by the backend, e.g.
 * `profile_photos/abc123.jpg`) into a full authenticated URL that can be
 * rendered as an <img src>. The backend serves files with an `?auth=<jwt>`
 * query param.
 *
 * Returns null for missing/empty paths so callers can render a fallback.
 *
 * If the path is already a fully-qualified URL (http/https), return it
 * unchanged — this handles legacy records and public-CDN paths.
 */
export function getPhotoUrl(path, token) {
  if (!path) return null;
  if (typeof path !== 'string') return null;
  if (/^https?:\/\//i.test(path)) return path;
  const API_URL = process.env.REACT_APP_BACKEND_URL;
  if (!API_URL) return null;
  const authQuery = token ? `?auth=${encodeURIComponent(token)}` : '';
  return `${API_URL}/api/files/${path}${authQuery}`;
}
